import React, { useEffect, useState } from "react";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";
import { useNavigate } from "react-router-dom";

const CadastroCurso = () => {
  const [curso, setCurso] = useState({
    codigo: "",
    nome: "",
    nivel: "",
    modalidade: "",
    coordenadorId: "",
    disciplinasSelecionadas: [],
  });

  const [coordenadores, setCoordenadores] = useState([]);
  const [disciplinas, setDisciplinas] = useState([]);
  const [errors, setErrors] = useState({});
  const { parametros } = useCliente();
  const navigate = useNavigate();

  useEffect(() => {
    const clienteId = localStorage.getItem("cliente_id");

    axios.get(`/api/usuarios/coordenadores?cliente_id=${clienteId}`)
      .then(res => setCoordenadores(res.data))
      .catch(() => alert("Erro ao carregar coordenadores."));

    axios.get(`/api/disciplinas?cliente_id=${clienteId}`)
      .then(res => setDisciplinas(res.data))
      .catch(() => alert("Erro ao carregar disciplinas."));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurso(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleCheckboxChange = (id) => {
    setCurso(prev => {
      const selecionada = prev.disciplinasSelecionadas.includes(id);
      return {
        ...prev,
        disciplinasSelecionadas: selecionada
          ? prev.disciplinasSelecionadas.filter(d => d !== id)
          : [...prev.disciplinasSelecionadas, id],
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!curso.codigo.trim()) newErrors.codigo = "Código do curso é obrigatório.";
    if (!curso.nome.trim()) newErrors.nome = "Nome do curso é obrigatório.";
    if (!curso.nivel) newErrors.nivel = "Selecione o nível.";
    if (!curso.modalidade) newErrors.modalidade = "Selecione a modalidade.";
    if (!curso.coordenadorId) newErrors.coordenadorId = "Selecione um coordenador.";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const clienteId = localStorage.getItem("cliente_id");

    const payload = {
      ...curso,
      disciplinasSelecionadas: curso.disciplinasSelecionadas.map(id => parseInt(id, 10)),
      coordenadorId: parseInt(curso.coordenadorId, 10),
      cliente_id: parseInt(clienteId, 10),
      usuario_id: parseInt(localStorage.getItem("user_id"), 10)
    };

    axios.post(`/api/cursos`, payload)
      .then(() => {
        alert("Curso cadastrado com sucesso!");
        navigate("/cursos");
        setCurso({
          codigo: "",
          nome: "",
          nivel: "",
          modalidade: "",
          coordenadorId: "",
          disciplinasSelecionadas: [],
        });
        setErrors({});
      })
      .catch(() => {
        alert("Erro ao cadastrar curso.");
      });
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Cadastro de Curso</h2>
      <form onSubmit={handleSubmit}>

      <div className="form-linha-1">
        <div className="form-group cod" style={{ width: "180px", maxWidth: "180px" }}>
          <label>Código do Curso:</label>
          <input type="text" name="codigo" value={curso.codigo} onChange={handleChange} />
          {errors.codigo && <span className="erro">{errors.codigo}</span>}
        </div>
      <div className="form-group" style={{ flex: 1 }}>
        <label>Nome do Curso:</label>
        <input type="text" name="nome" value={curso.nome} onChange={handleChange} />
        {errors.nome && <span className="erro">{errors.nome}</span>}
     </div>
    </div>


        <div className="form-linha-2">
          <div className="form-group">
            <label>Nível:</label>
            <select name="nivel" value={curso.nivel} onChange={handleChange}>
              <option value="">Selecione...</option>
              <option value="Ensino Médio">Ensino Médio</option>
              <option value="Preparatório">Preparatório</option>
              <option value="Graduação/Pós">Graduação/Pós</option>
              <option value="PJ RH/T&D">PJ RH/T&D</option>
            </select>
            {errors.nivel && <span className="erro">{errors.nivel}</span>}
          </div>

          <div className="form-group">
            <label>Modalidade:</label>
            <select name="modalidade" value={curso.modalidade} onChange={handleChange}>
              <option value="">Selecione...</option>
              <option value="Presencial">Presencial</option>
              <option value="Híbrido">Híbrido</option>
              <option value="Live">Live</option>
              <option value="EAD">EAD</option>
              <option value="Outros">Outros</option>
            </select>
            {errors.modalidade && <span className="erro">{errors.modalidade}</span>}
          </div>

          <div className="form-group">
            <label>Coordenador:</label>
            <select name="coordenadorId" value={curso.coordenadorId} onChange={handleChange}>
              <option value="">Selecione...</option>
              {coordenadores.map(c => (
                <option key={c.id} value={c.id}>{c.nome_completo}</option>
              ))}
            </select>
            {errors.coordenadorId && <span className="erro">{errors.coordenadorId}</span>}
          </div>
        </div>

        <hr className="linha-divisoria" />

        {disciplinas.length > 0 && (
          <div className="form-group full-width">
            <label>Disciplinas do Curso:</label>
            <div style={{ overflowX: "auto", marginTop: "10px" }}>
              <table className="tabela" style={{ fontSize: "0.75rem" }}>
                <thead
                  style={{
                    backgroundColor: parametros?.cor_cabecalho || "#156082",
                    color: "white"
                  }}
                >
                  <tr>
                    <th style={{ width: "10%", textAlign: "center" }}>Selecionar</th>
                    <th style={{ width: "20%", textAlign: "left" }}>Código</th>
                    <th style={{ textAlign: "left" }}>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  {disciplinas.map((d) => (
                    <tr key={d.id}>
                      <td style={{ textAlign: "center", padding: "8px" }}>
                        <input
                          type="checkbox"
                          checked={curso.disciplinasSelecionadas.includes(d.id)}
                          onChange={() => handleCheckboxChange(d.id)}
                        />
                      </td>
                      <td style={{ padding: "8px" }}>{d.codigo}</td>
                      <td style={{ padding: "8px" }}>{d.nome}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          <button type="button" className="btn btn-secondary" onClick={() => window.history.back()}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroCurso;


